import { useEffect } from 'react';
import { useIsFocused } from '@react-navigation/native';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewLikedFolder = (isActive: boolean) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (!isFocused || !isActive) return;
    logAnalyticsEvent({
      name: 'VIEW_LIKED_FOLDER',
      channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
    });
  }, [isFocused, isActive, logAnalyticsEvent]);
};
